module.exports = __webpack_public_path__ + "static/media/logo-stg2.5a708b33.svg";